module.exports = __webpack_public_path__ + "img/spoken-training-word-active.a58f4904.svg";